import React, { useEffect, useState } from 'react'
import { Formik, Form } from 'formik'
import { FaCheck } from 'react-icons/fa'

import Yup from '~/services/yup'
import { api } from '~/services/api'

import ActionFooter from '~/components/ActionFooter'
import {
    Button, Textbox, Select, Checkbox 
} from '~/components/Form'
import Modal from '~/components/Modal'

import { Container, TermoContainer, ModalTermoContainer } from './styles'

const validation = Yup.object({
    banco: Yup.string().required('Selecione o banco.'),
    agencia: Yup.string().required('Digite o número da agência.'),
    conta: Yup.string().required('Digite o número da conta.'),
    autorizado: Yup.boolean()
})

export default function ({ onSubmit, valorMensalidade }) {
    const [bancos, setBancos] = useState([])
    const [showTermoCiencia, setShowTermoCiencia] = useState(false)
    const [initialValues, setInitialValues] = useState({ 
        banco: '',
        agencia: '',
        conta: '',
        autorizado: false
    })
	
    useEffect(() => {
        async function loadBancos() {
            const response = await api.get('instituicao?type=banco&desconto=1')
			
            setBancos(response)
        }

        loadBancos()

        const storedData = JSON.parse(localStorage.getItem('sindmepa-associacao-temp-data'))
    
        if(storedData?.financeiro) {
            setInitialValues({
                ...storedData.financeiro,
                autorizado: false
            })
        }
    }, [])
	
    return (
        <Container>
            <Formik
                initialValues={initialValues}
                validationSchema={validation}
                onSubmit={onSubmit}
                enableReinitialize
            >
                {({ isSubmitting, setFieldValue }) => (
                    <Form>
                        <Select 
                            name="banco"
                            label="Banco"
                            onChange={selected => setFieldValue('banco', selected)}
                            options={bancos.map(banco => ({
                                label: banco.razao_social,
                                value: banco.id
                            }))}
                            containerClass="banco-container"
                        />

                        <Textbox 
                            label="Agência" 
                            name="agencia"
                            inputMode="numeric"
                        />

                        <Textbox 
                            label="Conta" 
                            name="conta"
                            inputMode="numeric"
                        />

                        <TermoContainer>
                            <Button onClick={() => setShowTermoCiencia(true)} className="transparent">
                                VER TERMO DE CIÊNCIA
                            </Button>
                        </TermoContainer>

                        <Checkbox 
                            name="autorizado" 
                            label={`Li e concordo com o Termo de Ciência acima e autorizo o desconto da mensalidade através de débito em minha conta corrente, no dia 10 de cada mês, com valor correspondente a R$ ${valorMensalidade.toFixed(2).replace('.', ',')} em favor do Sindicato dos Médicos do Pará. Estou ciente que este valor será reajustado anualmente no mês de janeiro.`}
                            handleChange={e => { setFieldValue(e.target.name, e.target.checked) }}
                            containerStyle={{ gridArea: 'check' }}
                        />

                        <ActionFooter>
                            <Button type="submit" loading={isSubmitting} className="white">
                                Concluir
                                <FaCheck />
                            </Button>
                        </ActionFooter>
                    </Form>
                )}
            </Formik>

            <Modal
                isOpen={showTermoCiencia}
                handleClose={() => setShowTermoCiencia(false)}
                title="Termo de Ciência do Associado"
            >
                <ModalTermoContainer>
                    <iframe src={`${process.env.REACT_APP_BACKEND_URL}/resources/TERMO DE CIENCIA SINDMEPA.pdf`} frameBorder="0" title="Termo de Ciência" />
                </ModalTermoContainer>
            </Modal>
        </Container>
    )
}
